<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form #fr="ngForm" [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
        <div class="grid form-group">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'CONVENIOSPLANESCARGOS.LBL_CODIGOCONVENIO' | translate }}</label>
              <input name="nomcodigoConvenio" id="idcodigoConvenio" type="text" pInputText *ngIf="!actualizar"
                     [maxLength]="11" formControlName="codigoConvenio" autocomplete="false"
                     appTexto document-type [sinEspacio]="true" required="true">
              <label *ngIf="actualizar" class="falso-combo-texto" style="background: #b7b3b36e">{{f.codigoConvenio.value}}</label>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoConvenio.invalid">
                {{ 'CONVENIOSPLANESCARGOS.LBL_CODIGOCONVENIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'CONVENIOSPLANESCARGOS.LBL_NOMCONVENIO' | translate }}</label>
              <input name="nombreConvenio" id="idnombreConvenio" type="text" pInputText
                     [maxLength]="250" formControlName="nombreConvenio" autocomplete="false"
                     appTexto document-type [sinNumeros]="true" required="true">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombreConvenio.invalid">
                {{ 'CONVENIOSPLANESCARGOS.LBL_NOMCONVENIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>{{ 'CONVENIOSPLANESCARGOS.LBL_DESCRIPCION' | translate }}</label>
              <textarea id="idDescripcion" name="nomDescripcion" pInputTextarea rows="2"
                        capitalize-reactive maxlength="500"
                        formControlName="descripcion"></textarea>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
              <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div  *ngIf="!guardando">
              <a (click)="cancelar((fr.dirty === true))" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
      <p-confirmDialog #cd>
        <p-footer>
          <button type="button" pButton icon="fa fa-close" label="{{ 'BTN_NO' | translate}}" (click)="cd.reject()"></button>
          <button type="button" pButton icon="fa fa-check" label="{{ 'BTN_SI' | translate}}" (click)="cd.accept()"></button>
        </p-footer>
      </p-confirmDialog>
    </div>
  </div>
</div>

